import React from 'react';
import ReactDOM from 'react-dom';
import 'custom.scss';
import App from 'App.js';
import * as serviceWorker from 'serviceWorker.js';
import { Provider } from 'react-redux'; // provider passes store to every container component
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import multi from 'redux-multi'; //allows multi actions array
import 'bootstrap/dist/css/bootstrap.min.css';
import { rootReducer, initialState } from 'reducers.js';
//import { createLogger } from 'redux-logger';

const middleware = [thunk, multi];

//middleware.push(createLogger());

export const store = createStore(
	rootReducer,
	initialState,
	applyMiddleware(...middleware)
);

ReactDOM.render(
	<Provider store={store}>
		{/* <React.StrictMode> */}
		<App />
		{/* </React.StrictMode> */}
	</Provider>,
	document.getElementById('root')
);

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
